import { WhereItems } from ".";
import { RowKey } from "../requests/table/types";

export const ASCENDING = "asc";
export const DESCENDING = "desc";

export type OrderValue = typeof ASCENDING | typeof DESCENDING;

/* BASIC ITEMS */
export type OrderItem = {
  order: OrderValue | null;
  rank: number;
};

export type Order = { [column: string]: OrderItem };

export type SOR = {
  order: Order;
  search: WhereItems;
  relatedTemplateRowKey?: RowKey;
  detailTemplateJoinConditionId?: string;
};
